const RESURL = window.location.protocol + '//' + document.domain || 'https://shop.anquanfan.com'
console.log(RESURL)
// appId列表
const configs = {
  'http://localhost': { // 测试地址
    baseTitle: '安全数字',
    kf_qrCode: '/static/img/code.jpg',
    kf_weixin: 'yr29809',
    appId: 'wx0345dad74e6e4b5d', // 测试地址
    bgImg: '/static/img/bg1.png' // 首页背景图
  },
  'http://wx-web.frp.weizhi.so': {
    baseTitle: '安全数字',
    kf_qrCode: '/static/img/code.jpg',
    kf_weixin: 'yr29809',
    title: '安全数字互动营销服务平台v1.0.19',
    appId: 'wx0345dad74e6e4b5d', // 测试地址
    bgImg: '/static/img/bg2.png', // 首页背景图
    exchangeBgImg: '/static/img/exchange_bg2.png' // 回填订单页面背景图

  },
  // 'https://hd.anquanfan.com': {
  //     baseTitle: "安全数字",
  //     kf_qrCode: "/static/img/code.jpg",
  //     kf_weixin: "yr29809",
  //     title: '安全数字互动营销服务平台v1.0.18',
  //     appId: 'wx5ce0abe3f4d11c2b',
  //     bgImg: '/static/img/bg1.png', //首页背景图
  //     exchangeBgImg: '/static/img/exchange_bg1.png', //回填订单页面背景图
  // },
  'https://wx.22saas.com': {
    baseTitle: 'onesaas',
    kf_qrCode: '/static/img/aqz_qrcode.pic.jpg',
    kf_weixin: null,
    title: 'onesaas互动营销服务平台',
    appId: 'wx979557ca776a567a',
    bgImg: '/static/img/bg2.png', // 首页背景图
    exchangeBgImg: '/static/img/exchange_bg2.png' // 回填订单页面背景图

  }
}
const initConfig = { // 默认数据，都匹配不上时使用
  baseTitle: 'onesaas',
  kf_qrCode: '/static/img/code.jpg',
  kf_weixin: 'yr29809',
  title: 'onesaas互动营销服务平台',
  appId: 'wx979557ca776a567a',
  bgImg: '/static/img/bg1.png', // 首页背景图
  exchangeBgImg: '/static/img/exchange_bg1.png' // 回填订单页面背景图
}
let data = configs[RESURL] || ''
let configDatas = initConfig
if (data) {
  configDatas = data
}
configDatas['RESURL'] = RESURL
export { configDatas }



// WEBPACK FOOTER //
// ./src/configs.js